import { render, staticRenderFns } from "./MoreInvestmentAlternativesStepsDialog.vue?vue&type=template&id=5ae4f0d9&scoped=true&"
import script from "./MoreInvestmentAlternativesStepsDialog.vue?vue&type=script&lang=ts&"
export * from "./MoreInvestmentAlternativesStepsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MoreInvestmentAlternativesStepsDialog.vue?vue&type=style&index=0&id=5ae4f0d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae4f0d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VDivider,VIcon,VImg,VRow})
